export default __webpack_public_path__ + "static/media/valohai.02f2956b.svg";